"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

import SaveSearchIcon from "assets/svg/save_search.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Button from "components/common/button";
import ModalTextContent from "components/modal-text-content";
import SaveSearchForm from "components/listing-search/save-search-form";
import LoginForm from "components/login/forms/login";
import ForgotPasswordForm from "components/login/forgot-password-form";

import styles from "./styles.module.css";

const Modal = dynamic(() => import("components/common/modal"), { ssr: false });

const SaveSearchCard = ({ name, urlPath }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isForgotPasswordForm, setIsForgotPasswordForm] = useState(false);
  const [forgotFormMail, setForgotFormMail] = useState("");
  const [isLogin, setIsLogin] = useState(false);

  const handleModalClose = () => {
    setIsForgotPasswordForm(false);
    setIsModalOpen(false);
  };

  const handleForgotButton = () => {
    setIsForgotPasswordForm(!isForgotPasswordForm);
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
    Ga4WithEventParameters({
      eventName: "click_button",
      eventParameters: { label: "aramayi-kaydet" },
    });
  };

  useEffect(() => {
    const mail = localStorage.getItem("forgot-password-user");
    setForgotFormMail(mail);
    const isLogin = localStorage.getItem("user-data");
    setIsLogin(isLogin);
  }, []);

  const renderModal = () => {
    if (!isLogin) {
      return (
        <ModalTextContent>
          {!isForgotPasswordForm ? (
            <LoginForm modal handleForgotButton={handleForgotButton} successCallback={() => setIsLogin(true)} />
          ) : (
            <ForgotPasswordForm modal defaultMail={forgotFormMail} handleBackButtonForgotForm={handleForgotButton} />
          )}
        </ModalTextContent>
      );
    } else {
      return (
        <ModalTextContent>
          <SaveSearchForm name={name} urlPath={urlPath} />
        </ModalTextContent>
      );
    }
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.infoWrapper}>
        <div className={styles.icon}>
          <SaveSearchIcon />
        </div>
        <p className={styles.info}>
          Aramanıza uygun yeni bir ilan yayınlandığında <b>ilk sizin haberiniz olsun.</b>
        </p>
      </div>
      <div className={styles.buttonWrapper}>
        <Button onClick={handleModalOpen} buttonClass={styles.buttonClass} outline size="M">
          Aramayı Kaydet
        </Button>
      </div>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} handleClose={() => handleModalClose()}>
          {renderModal()}
        </Modal>
      )}
    </div>
  );
};

SaveSearchCard.propTypes = {
  name: PropTypes.string,
  urlPath: PropTypes.string,
};

export default SaveSearchCard;
